module.exports = __webpack_public_path__ + "media/assets/faria_products/SSO Google-83c0bb7c85c70134a9845dbcd4ac567c73ca957048db65d0fcc950bccfcf5b76.png";